<template>
  <div class="banner-news">
    <el-carousel :interval="5000" arrow="never" style="width: 815px;" width="815px" height="449px">
      <el-carousel-item v-for="item in articles" :key="item.id">
        <a :href="item.url ? item.url : `/news/info/${item.plateid}/${item.uuid}`" :target="item.url ? '_blank' : '_self'">
          <img :src="`${IP_TEST}/uploads/${item.picsrc}`" width="815" height="449" alt="" />
          <h1>{{ item.title }}</h1>
        </a>
      </el-carousel-item>
    </el-carousel>
    <div class="infonews">
      <div class="info">
        <div class="itembottom">
          <div class="item">
            <span v-for="(item, index) in INFO_LIST" :class="{ first: index === 0, active: activeInfoIndex === index }"
              :key="index" v-text="item" @click="changeInfo(index,'新闻动态',item)">
            </span>
            <router-link tag="a" class="gengduo" :to="`/news/views/${plateIdInfo}/${pxChildPlateId}`">
            </router-link>
          </div>
          <div class="itemlist">
            <ul class="list">
              <li v-for="item in infos" :key="item.id">
                <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" :title="item.title">{{ item.title }}
                </router-link>
                <span>{{ item.addtime | datefilter }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsViews, getPicNews } from '@/request/get'
import { INFO_NEWS, IP_TEST, INFO_LIST } from '@/config'
export default {
  name: "Banner",
  data() {
    return {
      articles: [],
      IP_TEST,
      activeInfoIndex: 0,
      INFO_LIST: INFO_LIST,
      INFO_NEWS: INFO_NEWS,
      plateIdInfo: "",
      pxChildPlateId: "",
      infos: []
    }
  },
  created() {
    this.changeInfo(0, '新闻动态', this.INFO_NEWS);
    this.getPicNews()
  },
  filters: {
    datefilter(value) {
      return value.slice(5, 10);
    }
  },
  methods: {
    _sortByTop(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].top == "1") {
          arr.unshift(arr[i]);
          arr.splice(i + 1, 1);
          break;
        }
      }
      return arr;
    },
    async getPicNews() {
      let result = await getPicNews();
      result = result.data;
      this.articles = result && this._sortByTop(result);
    },
    async getNewsViews(uuid, childuuid) {
      let result = await getNewsViews(uuid, 1, 7, childuuid);
      result = result.data;
      this.infos = result || [];
    },
    changeInfo(index, name, childname) {
      this.activeInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.plateIdInfo = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == childname);
      this.pxChildPlateId = childPlate[0].uuid;
      this.getNewsViews(this.plateIdInfo, this.pxChildPlateId);
    }
  }
};
</script>
<style scoped>
.banner-news {
  position: relative;
  width: 100%;
  margin-top: 38px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.leftnews {
  width: 632px;
  height: 383px;
  /* background: #fff; */
  display: inline-block;
}

.swiper {
  position: relative;
  width: 620x;
  margin-left: 10px;
  height: 371px;
  overflow: hidden;
  background: #fff;
  /* margin: 0 10px 0 10px; */

}

.swiper-slide {
  text-align: left;
  font-size: 18px;
  /* background: #fff; */
  width: 416px;
  line-height: 344px;
}

.infonews {
  width: 460px;
  height: 340px;
  margin-left: 19px;
}

.infonews>.info>.itembottom {
  width: 460px;
}

.infonews>.info>.itembottom {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
}

.infonews>.info>.itembottom>.item {
  position: relative;
  display: flex;
  justify-content: start;
  text-align: center;
  height: 52px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000;
  margin-bottom: 13px;
}
.infonews>.info>.itembottom>.item:before {
  position: absolute;
  top:0;
  left: 0;
  content: "";
  display: inline-block;
  width: 8px;
  height: 24px;
  background: #2E8EEB;
}
.infonews>.info>.itembottom>.item>span {
  cursor:pointer;
  margin: 0 25px;
  overflow: hidden;
}

.infonews>.info>.itembottom>.item>span.active {
  color: #2E8EEB;
}

.infonews>.info>.itembottom>.itemlist {
  width: 613px;
  height: 384px;
  display: flex;
  justify-content: start;
  /* padding:0 38px 0 38px; */
}

.infonews>.info>.itembottom>.itemlist>.list {
  display: flex;
  flex-direction: column;
  justify-content: start;
  overflow: hidden;
  border-bottom: 1px solid #F7F7F7;
}

.infonews>.info>.itembottom>.itemlist>.list>li {
  position: relative;
  height: 15px;
  margin-bottom: 41px;
  display: flex;
  justify-content: start;
  align-items: center;
  /* border-bottom: 1px solid #D9D9D9; */
}

.infonews>.info>.itembottom>.itemlist>.list>li::after{
  position: absolute;
  bottom: 35px;
  content: "";
  width: 456px;
    height: 1px;
    background: #e4dfdf;
}

.infonews>.info>.itembottom>.itemlist>.list>li:before {
  background: #2E8EEB;
  border-radius: 50%;
  content: "";
  display: inline-block;
  height: 6px;
  width: 6px;
}

.infonews>.info>.itembottom>.itemlist>.list>li>a {
  width: 331px;
  height: 53px;
  margin-right: 28px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 53px;
  overflow: hidden;
  word-break: break-all;
  /* display: -webkit-box; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-left: 12px;
  /* overflow: hidden; */
}

.infonews>.info>.itembottom>.itemlist>.list>li>span {
  width: 80px;
  height: 53px;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  line-height: 53px;
  text-align: right;
}

/deep/ .el-carousel--horizontal {
  overflow: hidden;
}

.gengduo {
  position: absolute;
  top: 0;
  right: 3px;
  width: 32px;
  height: 52px;
  color: #E54440;
  line-height: 52px;
  font-size: 16px;
  font-weight: normal;
  background-image: url(/static/img/img/youbi.png);
  background-repeat: no-repeat;
  background-size: 32px 17px;
  background-position: right top;
}
div >>>.el-carousel__indicators .is-active button{ 
  background: #2E8EEB;
}
</style>


